import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3557e030"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "RPKListItem" }
const _hoisted_2 = { class: "flex justify-between" }
const _hoisted_3 = { class: "font-semibold" }
const _hoisted_4 = { class: "RPKListItem__content" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "flex w-full justify-end" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash mr-2" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen mr-2" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-link mr-2" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cheap = _resolveComponent("cheap")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, " Компания: " + _toDisplayString(_ctx.item.company_name) + " (ID: " + _toDisplayString(_ctx.item.id) + ") ", 1),
      _createVNode(_component_cheap, {
        class: _normalizeClass(["small ml-4", `${_ctx.getStatusColor(_ctx.item.status_id)}`])
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Статус: " + _toDisplayString(_ctx.item.status_name || 'Нет статуса') + ", тип РПК: " + _toDisplayString(_ctx.item.type_title || 'Нет данных'), 1)
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", null, "Дата РПК: " + _toDisplayString(_ctx.formatDate(_ctx.item.pbc_date)), 1),
      _createElementVNode("span", null, "Контрагент: " + _toDisplayString(_ctx.item.company_name || '-'), 1),
      _createElementVNode("span", null, "Дата оборота: " + _toDisplayString(_ctx.formatDate(_ctx.item.turnover_date)), 1),
      _createElementVNode("span", null, "Город: " + _toDisplayString(_ctx.item.city_name || '-'), 1),
      _createElementVNode("span", null, "Дата акта: " + _toDisplayString(_ctx.formatDate(_ctx.item.act_date)), 1),
      _createElementVNode("span", null, "Курьер: " + _toDisplayString(_ctx.item.driver_name || '-'), 1),
      _createElementVNode("span", null, "Номер акта: " + _toDisplayString(_ctx.item.act_number || '-'), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.getCostTitle) + ": " + _toDisplayString(_ctx.getCost), 1),
      _createElementVNode("span", null, [
        _createTextVNode(" Номер FTL-заказа: "),
        (_ctx.item.ftl_order_id)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: `/ftl-orders/${_ctx.item.ftl_order_id}`,
              target: "_blank",
              class: "RPKListItem__link"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.item.ftl_order_id), 1)
              ]),
              _: 1
            }, 8, ["to"]))
          : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.item.ftl_order_id || '-'), 1))
      ]),
      _createElementVNode("span", null, "Кем одобрено: " + _toDisplayString(_ctx.item.approver?.name || '-'), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_the_button, {
        class: "text small red",
        onClick: _ctx.emitDelete
      }, {
        default: _withCtx(() => [
          _hoisted_7,
          _createTextVNode(" Удалить ")
        ]),
        _: 1
      }, 8, ["onClick"]),
      (_ctx.item.status_id === 13)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: `/rpk/edit/${_ctx.item.id}`,
            target: "_blank"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_the_button, { class: "text small primary" }, {
                default: _withCtx(() => [
                  _hoisted_8,
                  _createTextVNode(" Редактировать ")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true),
      (_ctx.item.ftl_order_id)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            to: `/ftl-orders/${_ctx.item.ftl_order_id}`
          }, {
            default: _withCtx(() => [
              _createVNode(_component_the_button, { class: "text small primary" }, {
                default: _withCtx(() => [
                  _hoisted_9,
                  _createTextVNode("Открыть FTL заказ ")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true),
      _createVNode(_component_router_link, {
        to: `/rpk/${_ctx.item.id}`,
        target: "_blank"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_the_button, { class: "text small primary" }, {
            default: _withCtx(() => [
              _hoisted_10,
              _createTextVNode("Подробнее ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["to"])
    ])
  ]))
}